import FAQLink from "./overview/FAQLink";
import style from "./GuidelineOverview.module.scss";

const GuidelineOverview = () => {
  return (
    <div className={style.guidelineOverview}>
      <div className={style.leftPanel}></div>
      <div className={style.rightPanel}>
        <FAQLink></FAQLink>
      </div>
    </div>
  );
}

export default GuidelineOverview;